module.exports = __webpack_public_path__ + "img/n_rule.b58a517d.jpg";